import React, { useState } from 'react';
import { FaAngleDown } from "react-icons/fa";
import submitBanner from "../assets/images/submitBanner.jpg"
import axios from "axios";
import config from '../config';
const options = [
    "I'm an interior designer a general contractor",
    "I'm a real estate agent looking for a general contractor",
    "I want to build or renovate my own home",
    "I'm a property developer looking for more service providers"
];

const ContactPopup = ({ setPopup }) => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        number: '',
        projectType: '',
        footage: '',
        location: '',
        startDate: '',
        details: '',
    });
    const [currentStep, setCurrentStep] = useState(1);
    const [selected, setSelected] = useState('');
    const [errors, setErrors] = useState({});

    const validateStep1 = () => {
        const newErrors = {};
        if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
        if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Invalid email format';
        }
        if (!formData.number.trim()) {
            newErrors.number = 'Phone number is required';
        } else if (!/^\+?\d{10,15}$/.test(formData.number.replace(/\D/g, ''))) {
            newErrors.number = 'Invalid phone number (10-15 digits)';
        }
        return newErrors;
    };

    const validateStep2 = () => {
        const newErrors = {};
        if (!selected) newErrors.selected = 'Please select an option';
        return newErrors;
    };

    const validateStep3 = () => {
        const newErrors = {};
        if (!formData.projectType) newErrors.projectType = 'Project type is required';
        if (!formData.footage) newErrors.footage = 'Square footage is required';
        if (!formData.location.trim()) newErrors.location = 'Location is required';
        if (!formData.startDate) newErrors.startDate = 'Estimated start date is required';
        return newErrors;
    };

    const validateStep4 = () => {
        const newErrors = {};
        if (!formData.details.trim()) newErrors.details = 'Details are required';
        return newErrors;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const step4Errors = validateStep4();
        if (Object.keys(step4Errors).length > 0) {
            setErrors(step4Errors);
            return;
        }

        const dataToSend = {
            ...formData,
            projectType: formData.projectType || selected
        };

        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/enquiry`, dataToSend);
            console.log('Response:', response.data);
            setCurrentStep(5);
        } catch (error) {
            console.error('API Error:', error);
            alert("Something went wrong while submitting the form.");
        }
    };

    const handleNext = () => {
        let newErrors = {};

        if (currentStep === 1) newErrors = validateStep1();
        else if (currentStep === 2) newErrors = validateStep2();
        else if (currentStep === 3) newErrors = validateStep3();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setCurrentStep(currentStep + 1);
    };

    return (
        <>
            <div className='contact-popup popup-block position-fixed top-0 start-0 w-100 h-100 d-flex align-end d-align-center justify-center p-0 d-p-20'>
                <div className='content-wrapper bg-light-gray position-relative'>
                    <button
                        type="button"
                        className="close-popup-btn position-absolute"
                        style={{ top: 16, right: 16, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', zIndex: 10 }}
                        aria-label="Close"
                        onClick={() => setPopup(false)}
                    >
                        &times;
                    </button>
                    <div className='contact-head pb-20'>
                        <h2 className='mb-20'><span className='font-regular'>get started</span> with Ivey</h2>
                        <div className='progress-bar-track'>
                            <div className='progress-bar' style={{ width: `${currentStep * 20}%` }} ></div>
                        </div>
                    </div>
                    <div className='contact-form-wrapper'>
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className={`steps step-1 mb-20 d-mb-150 ${currentStep === 1 ? '' : 'd-none'}`}>
                                <div className='form-title uppercase font-medium font-12 pb-15 d-ps-15'>About You</div>
                                <div className='form-field-wrapper d-grid gap-10'>
                                    <div className='form-fields d-grid d-column-2 gap-10'>
                                        <div className='form-field'>
                                            <input type="text" name="firstName" placeholder="first name" onChange={handleChange} />
                                            {errors.firstName && <span className="error">{errors.firstName}</span>}
                                        </div>
                                        <div className='form-field'>
                                            <input type="text" name="lastName" placeholder="last name" onChange={handleChange} />
                                            {errors.lastName && <span className="error">{errors.lastName}</span>}
                                        </div>
                                    </div>
                                    <div className='form-fields d-grid d-column-2 gap-10'>
                                        <div className='form-field'>
                                            <input type="email" name="email" placeholder="email" onChange={handleChange} />
                                            {errors.email && <span className="error">{errors.email}</span>}
                                        </div>
                                        <div className='form-field'>
                                            <input type="text" name="number" placeholder="number" onChange={handleChange} />
                                            {errors.number && <span className="error">{errors.number}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-action text-right mt-30 z-index-2">
                                    <button type="button" className="button" onClick={handleNext}>Next</button>
                                </div>
                            </div>
                            <div className={`steps step-2 mb-20 d-mb-40 ${currentStep === 2 ? '' : 'd-none'}`}>
                                <div className='form-title uppercase font-medium font-12 pb-15 d-ps-15'>About You:</div>
                                <div className='form-field-wrapper d-grid gap-10'>
                                    <div className="form-options d-grid gap-15">
                                        {options.map((option, index) => (
                                            <button
                                                type="button"
                                                key={index}
                                                className={`option-button ${selected === option ? 'selected' : ''}`}
                                                onClick={() => { setSelected(option); setErrors({ ...errors, selected: '' }); }}
                                            >
                                                {option}
                                            </button>
                                        ))}
                                        {errors.selected && <span className="error">{errors.selected}</span>}
                                    </div>
                                </div>
                                <div className="form-action text-right mt-30 z-index-2">
                                    <button type="button" className="button" onClick={handleNext}>Next</button>
                                </div>
                            </div>

                            <div className={`steps step-3 mb-20 d-mb-150 ${currentStep === 3 ? '' : 'd-none'}`}>
                                <div className='form-title uppercase font-medium font-12 pb-15 d-ps-15'>About Your Project</div>
                                <div className='form-field-wrapper d-grid gap-10'>
                                    <div className='form-fields d-grid d-column-2 gap-10'>
                                        <div className='form-field position-relative'>
                                            <FaAngleDown className='arrow position-absolute' />
                                            <select name="projectType" onChange={handleChange}>
                                                <option value="">type of project</option>
                                                <option value="residential">Residential</option>
                                                <option value="commercial">Commercial</option>
                                            </select>
                                            {errors.projectType && <span className="error">{errors.projectType}</span>}
                                        </div>
                                        <div className='form-field position-relative'>
                                            <FaAngleDown className='arrow position-absolute' />
                                            <select name="footage" onChange={handleChange}>
                                                <option value="">sq. footage</option>
                                                <option value="<1000"> &lt;1000 sqft</option>
                                                <option value="1000-3000">1000–3000 sqft</option>
                                                <option value="3000+">3000+ sqft</option>
                                            </select>
                                            {errors.footage && <span className="error">{errors.footage}</span>}
                                        </div>
                                    </div>
                                    <div className='form-fields d-grid d-column-2 gap-10'>
                                        <div className='form-field'>
                                            <input type="text" name="location" placeholder="type a location" onChange={handleChange} />
                                            {errors.location && <span className="error">{errors.location}</span>}
                                        </div>
                                        <div className='form-field position-relative'>
                                            <FaAngleDown className='arrow position-absolute' />
                                            <select name="startDate" onChange={handleChange}>
                                                <option value="">est. start date</option>
                                                <option value="soon">ASAP</option>
                                                <option value="1-3">1-3 months</option>
                                                <option value="3+">3+ months</option>
                                            </select>
                                            {errors.startDate && <span className="error">{errors.startDate}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-action text-right mt-30 z-index-2">
                                    <button type="button" className="button" onClick={handleNext}>Next</button>
                                </div>
                            </div>
                            <div className={`steps step-4 mb-20 d-mb-30 ${currentStep === 4 ? '' : 'd-none'}`}>
                                <div className='form-title uppercase font-medium font-12 pb-15 d-ps-15'>Any Additional Details</div>
                                <div className='form-field-wrapper'>
                                    <div className='form-fields'>
                                        <div className='form-field'>
                                            <textarea name="details" placeholder="type a location" onChange={handleChange}></textarea>
                                            {errors.details && <span className="error">{errors.details}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-action text-right mt-30 z-index-2">
                                    <button type="submit" className="button">SEND</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className='contact-form-wrapper mb-20 d-mb-150'>
                        <div className='contact-wrapper steps step-1 mb-20 d-mb-150 sent'>
                            <div className={`submit-message position-absolute top-0 start-0 w-100 h-100 ${currentStep === 5 ? '' : 'd-none'}`}>
                                <div className='submit-message-wrapper position-relative color-dark w-100 h-100 px-30 d-px-50 py-50'>
                                    <img src={submitBanner} className=' cover position-absolute top-0 start-0 sm-hide' />
                                    <div className='summary position-relative z-index-1'>
                                        <h2 className='mb-10 font-regular'>Your message has been received by our team.</h2>
                                        <p>We will reach out to you as soon as possible.</p>
                                    </div>
                                </div>

                                <div className="form-action text-right mt-30 z-index-2">
                                    <button type="button" onClick={() => setPopup(false)} className="button">DONE</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ContactPopup





